import { Stack } from '@mui/material';
import { ContainedButton, OutlinedButton } from '../index';

export const ModalButton = (props) => {
  return (
    <Stack
      spacing={2}
      direction="row"
      sx={{ justifyContent: 'flex-end', mt: 1, ...props.style }}
    >
      <OutlinedButton
        onClick={props.secondaryClickHandler}
        btnTitle={props.secondaryBtnName}
        style={{ ...props.secondaryStyle }}
      />
      <ContainedButton
        onClick={props.primaryClickHandler}
        disabled={props.disable}
        variant="contained"
        btnTitle={props.primaryBtnName}
        style={{ width: 'auto', ...props.primaryStyle }}
      />
    </Stack>
  );
};
